import { Component, OnInit } from "@angular/core";
import { Utils } from "../../common/utils";
import { UsrCred } from "src/app/models/usrcred";
import { VproService } from "src/app/service/vpro/vpro.service";

@Component({
  selector: "app-navbar-component",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  user = new UsrCred();
  data: Number;
  constructor(private loginService: VproService, private utils: Utils) { }

  ngOnInit() {
    this.data = JSON.parse(localStorage.getItem("LogUsrTyp"));
    if (this.utils.checkRoleType(Utils.USER_TYPE.physician, this.data)) {
      document.getElementById("nav-schedule-tab").style.display = "none";
    }
  }
}
